import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import UsersTableBody from './UsersTableBody';
import type { UsersTableProps } from './types';

const UsersTable = ({ showSpinner, setShowSpinner, usersList, fetchUsers, setShowUserCard }: UsersTableProps) => {
    const { t } = useTranslation();

    return (
        <>
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="UsersTable table-hover">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-username">{t('Users.theadUserName')}</td>
                            <td className="head-admin">{t('Users.theadAdmin')}</td>
                            <td className="head-status">{t('Users.theadStat')}</td>
                            <td className="head-action">{t('Users.theadActions')}</td>
                        </tr>
                    </thead>

                    <UsersTableBody
                        fetchUsers={fetchUsers}
                        usersList={usersList}
                        setShowUserCard={setShowUserCard}
                        setShowSpinner={setShowSpinner}
                    />
                </Table>
            </div>
        </>
    );
};

export default UsersTable;
